import { render, staticRenderFns } from "./team-players-list.vue?vue&type=template&id=0b4aa4c0&scoped=true&"
import script from "./team-players-list.vue?vue&type=script&lang=js&"
export * from "./team-players-list.vue?vue&type=script&lang=js&"
import style0 from "./team-players-list.vue?vue&type=style&index=0&id=0b4aa4c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4aa4c0",
  null
  
)

export default component.exports